import { collectStudyImageExportTargets } from './collectStudyImageTargets';
import type { StudyImageExportTarget } from './types';

export function buildSelectedJpegTargets(
  studyInstanceUID: string,
  selectedImageIds: string[],
  servicesManager: AppTypes.ServicesManager,
  extensionManager: AppTypes.ExtensionManager
): StudyImageExportTarget[] {
  const selectedSet = new Set(selectedImageIds);
  const studyTargets = collectStudyImageExportTargets(
    studyInstanceUID,
    servicesManager,
    extensionManager
  );

  const filtered = studyTargets.filter(target => selectedSet.has(target.imageId));

  return filtered.map((target, index) => ({
    ...target,
    exportIndex: index + 1,
  }));
}
